import { render, staticRenderFns } from "./ChangeRole.vue?vue&type=template&id=2106bb1a"
import script from "./ChangeRole.vue?vue&type=script&lang=js"
export * from "./ChangeRole.vue?vue&type=script&lang=js"
import style0 from "./ChangeRole.vue?vue&type=style&index=0&id=2106bb1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports